import { Helpers } from "@tpd-web-common-libs/nodejs-library";
import React, { ReactNode, useEffect, useState } from "react";
import {
  ContainerDiv,
  Logo,
  LogoWrapper,
  AccessibilityWrapper,
  IconWrapper,
} from "./PuHeader.style";

type TPuHeaderProps = {
  menuLivello1: any;
  configHeader: any;
  logoPath: string;
};

const PuHeader = (props: TPuHeaderProps) => {
  const { menuLivello1, configHeader, logoPath } = props;

  const enum MENU_LIVELLO_1_URLS {
    SERVIZIO_CLIENTI = "/tpdweb/servizio-clienti",
    TROVA_AGENZIE = "/tpdweb/trova-agenzie",
  }

  function renderContattiButton(): ReactNode {
    const contattiData = menuLivello1.map((menuData) => {
      if (menuData.url === MENU_LIVELLO_1_URLS.SERVIZIO_CLIENTI) {
        return (
          <IconWrapper href={Helpers.RouterHelper.normalizeHref(menuData.url)} title={menuData.name}>
            <i className={menuData.icon} />
          </IconWrapper>
        );
      }
    });
    return contattiData;
  }

  const storeCartAndRedirect = async () => {
    try {
      await Helpers.SessionHelper.setData("pu_data_props", {
        showCarrello: true,
      });
      Helpers.RouterHelper.goTo("/prodotto-unico");
    } catch (error) {
      console.error("Failed to store cart", error);
    }
  };

  //TODO: rebranding 2025, rerendering
  const [isClient, setIsClient] = useState(false)
 
  useEffect(() => {
    setIsClient(true)
  }, [])

  const RebrandingLogoSwitch = () => { 
    return Helpers.BrandNameHelper.brand() === Helpers.EBrand.UNIPOL ?
    <Logo src='/NextAssets/images/logo_unipol.svg' alt={`${Helpers.BrandNameHelper.brandName()} Logo`}/> :
    <Logo src='/NextAssets/images/logo_unipolsai.png' alt={`${Helpers.BrandNameHelper.brandName()} Logo`}/>
  }
  //END TODO

  return (
    <ContainerDiv>
      <LogoWrapper href="/homepage" title={`${Helpers.BrandNameHelper.brandName()} Assicurazioni`}>
        {/* {//TODO: logica per server side rebranding 2025, rerendering da eliminare a valle del rebranding } */
          isClient || !isClient ? 
          <RebrandingLogoSwitch></RebrandingLogoSwitch>
          : 
          <RebrandingLogoSwitch></RebrandingLogoSwitch>
        }
      </LogoWrapper>

      <AccessibilityWrapper>
        <IconWrapper aria-label="" onClick={storeCartAndRedirect}>
          <i className="icon-Cart" />
        </IconWrapper>
        {renderContattiButton()}
        {configHeader.account_menu && (
          <IconWrapper href="/accesso" aria-label="Accesso">
            <i className="icon-Area-riservata" />
          </IconWrapper>
        )}
      </AccessibilityWrapper>
    </ContainerDiv>
  );
};

export default PuHeader;
